<template>
  <div
    id="app"
    class="main_app_wrapper"
    :class="{
      with_english: whichLanguage == 'en',
      with_arabic: whichLanguage == 'ar',
    }"
  >
    <div>
      <app-navbar v-if="!$route.meta.hideNavbar"></app-navbar>
      <transition name="moveUp">
        <router-view />
      </transition>

      <app-footer v-if="!$route.meta.hideNavbar"></app-footer>
    </div>
    <AppLoading></AppLoading>
  </div>
</template>

<script>
export default {
  computed: {
    whichLanguage() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style lang="scss">
// AR
// @import url("https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@300;400;500;600;700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;500;600;700");
// EN
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,500;0,700;1,500");
// @import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;1,500;1,600");
.main_app_wrapper {
  &.with_english {
    direction: ltr;
    font-family: "Roboto", sans-serif;
    // font-family: "Poppins", sans-serif;
    .vti__input {
      // display: none;
      text-align: left;
    }
  }
  &.with_arabic {
    direction: rtl;
    // font-family: "Noto Sans Arabic", sans-serif;
    font-family: "Cairo", sans-serif;
    .vti__input {
      // display: none;
      text-align: right;
    }
  }
}

.moveUp-enter-active {
  animation: moveUp 0.5s ease-in;
}

@keyframes moveUp {
  0% {
    // transform: translateY(400px);
    opacity: 0;
  }
  100% {
    // transform: translateY(0);
    opacity: 1;
  }
}

.vti__dropdown-list {
  left: auto !important;
  right: 0 !important;
  text-align: center !important;
  width: 350px !important;
  overflow-x: hidden;
  border-radius: 10px !important;
  border: 1px solid $main_color !important;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15) !important;
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: $main_color;
    border-radius: 10px;
  }
}

// .just_for_country_code {
.vue-tel-input {
  border: none !important;
  width: 100%;

  &:focus-within {
    box-shadow: none !important;
    border: none !important;
  }
}
.vti__input {
  // display: none;
  text-align: end;
}
.vti__search_box {
  display: block;
  width: 100% !important;
  text-align: center;
  border: none !important;
  border-bottom: 1px solid $main_color !important;
  // &::placeholder {
  //   opacity: 0 !important;
  // }
}
// .vti__selection {
//   .vti__flag {
//     display: none !important;
//   }
// }
// }
.hide_telephone_input {
  .vue-tel-input {
    // width: auto;
    .vti__input {
      // display: none;
      &.vti__search_box {
        display: block;
      }
    }
  }
}
</style>
